export const DISTRICT_LIBRARY = 'DISTRICT_LIBRARY'

export const ASSESSMENTS = 'ASSESSMENTS'

export const STUDENT_PORTFOLIOS = 'STUDENT_PORTFOLIOS'

export const GRADEBOOK = 'GRADEBOOK'

export const GOOGLE_CLASSROOM_GRADE_PASSBACK = 'GOOGLE_CLASSROOM_GRADE_PASSBACK'
